import { Heading } from "components/common/Heading";
import {
  REPAYMENT_HOLIDAY_HEADING,
  REPAYMENT_HOLIDAY_TITLE2,
  REPAYMENT_HOLIDAY_TITLE2_SUB1,
  REPAYMENT_HOLIDAY_TITLE2_SUB2,
} from "./RequestRepaymentHoliday.const";

export const RequestRepaymentHolidayHeader = () => (
  <>
    <Heading title={REPAYMENT_HOLIDAY_HEADING} className="screen-header" />
    <ul className="heading">
      <li>
        <span>
          A repayment holiday gives you a <strong>6 month </strong>break from
          your loan repayments
        </span>
      </li>
      <li>
        <span>
          <strong>{REPAYMENT_HOLIDAY_TITLE2}</strong>
        </span>
        <ul>
          <li>
            <span>
              <strong>{REPAYMENT_HOLIDAY_TITLE2_SUB1}</strong>
            </span>
          </li>
          <li>
            <span>
              <strong>{REPAYMENT_HOLIDAY_TITLE2_SUB2}</strong>
            </span>
          </li>
        </ul>
      </li>
      <li>
        <span>
          In both cases interest will continue to accrue during the repayment
          holiday&nbsp;
          <strong>but you won’t have to make your regular repayments</strong>
        </span>
      </li>
      <li>
        <span>
          <strong>The total amount you owe will go up</strong> if you take a
          repayment holiday
        </span>
      </li>
      <li>
        <span>
          You can take up to <strong>3 capital repayment holidays</strong> and
          <strong> 1 capital & interest repayment holiday</strong> during your
          loan
        </span>
      </li>
      <li>
        <span>
          These repayment holidays are in addition to the
          <strong> 12 month repayment holiday</strong> you had at the start of
          your loan
        </span>
      </li>
    </ul>
  </>
);
